export default "__VITE_ASSET__DR4e6$iA__"